import { SoftDateTimePicker } from "@soft-db/ui";
import { DateTime } from "luxon";
import { formatTimeRange } from "../../utils/time-range";
import { AuditDateFilter } from "./audit-filter.type";

export default defineComponent({
	name: "AuditDateFilterConfiguration",
	props: {
		filter: {
			type: Object as PropType<AuditDateFilter>,
		},
	},
	setup(props, { emit }) {
		const { t } = useI18n();

		const filter = useVModel(props, "filter", emit);

		const timeRange = computed<[DateTime, DateTime] | []>(() => {
			if (filter.value?.type !== "date") return [];

			const { from, to } = filter.value;
			if (!from || !to) return [];

			return [DateTime.fromJSDate(from), DateTime.fromJSDate(to)];
		});

		function updateTimeRange(range: [DateTime, DateTime]) {
			if (filter.value?.type !== "date") return;

			const [start, end] = range;

			filter.value.from = start.toJSDate();
			filter.value.to = end.toJSDate();
		}

		function rangeFormatter(value: DateTime | [DateTime, DateTime] | []): string | null {
			if (!Array.isArray(value) || value.length !== 2) {
				return null;
			}

			const [start, end] = value;

			return formatTimeRange(start, end);
		}

		return () => (
			<SoftDateTimePicker
				modelValue={timeRange.value}
				label={t("common.range")}
				range
				formatter={rangeFormatter}
				max={DateTime.now()}
				onUpdate:modelValue={updateTimeRange as any}
			/>
		);
	},
});
